<form #exportForm
      [action]="exportServiceUrl()"
      method="POST"
      target="tdWbExportFrame"
      accept-charset="UTF-8">
  <textarea name="exportRequest"
            aria-label="Export request payload"
            [value]="exportRequest()">
  </textarea>
  <textarea name="exportParams"
            aria-label="Export parameters"
            [value]="exportParams()">
  </textarea>
  <textarea [attr.name]="CONSUMER_NAME_FIELD"
            aria-label="Consumer name"
            [value]="consumerName()">
  </textarea>
</form>
<!-- issue: posting a form to an iframe in chrome opens a new tab.
     solution: create the iframe element indirectly -->
<ng-container *ngTemplateOutlet="exportIframe" />
<ng-template #exportIframe>
  <iframe name="tdWbExportFrame"
          src="about:blank"
          aria-hidden="true">
  </iframe>
</ng-template>

